var map = {
	"./aral_komfort.svg": 3247,
	"./aral_plus.svg": 3248,
	"./bp_bonus.svg": 3249,
	"./bp_komfort.svg": 3250,
	"./bp_komfort_prepaid.svg": 3251,
	"./bp_plus.svg": 3252,
	"./fuel-card-active.svg": 3253,
	"./fuel-card-inactive.svg": 3254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3246;